module.exports = __webpack_public_path__ + "media/Ś.18d6fe4c.mp3";